import { useEffect, useState } from "react";

export const Card = ({ children, className = "", testid }) => (
  <div className={`ll-card-flat p-4 sm:p-6 ${className}`} data-testid={testid}>{children}</div>
);

export const Eyebrow = ({ children }) => (
  <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--ll-ink-muted)]">{children}</div>
);

export const Kpi = ({ label, value, sub, tone, testid }) => (
  <Card testid={testid}>
    <Eyebrow>{label}</Eyebrow>
    <div
      className="font-display font-bold text-2xl mt-2 font-mono-fin"
      style={{ color: tone === "bad" ? "var(--ll-error)" : tone === "good" ? "var(--ll-success)" : "var(--ll-ink)" }}
    >
      {value}
    </div>
    {sub && <div className="text-xs text-[var(--ll-ink-soft)] mt-1">{sub}</div>}
  </Card>
);

export const NumField = ({ label, value, onChange, step = "1", suffix, testid, min }) => (
  <label className="block">
    <span className="text-[10px] uppercase tracking-widest text-[var(--ll-ink-muted)]">{label}</span>
    <div className="mt-1 flex items-center border bg-white" style={{ borderColor: "var(--ll-border)" }}>
      <input
        type="number"
        step={step}
        min={min}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="w-full px-3 py-2 text-sm font-mono-fin outline-none"
      />
      {suffix && <span className="px-2 text-xs text-[var(--ll-ink-muted)]">{suffix}</span>}
    </div>
  </label>
);

export const btn = "text-sm px-3 py-2 inline-flex items-center gap-1.5 transition-opacity disabled:opacity-50";
export const btnDark = `${btn} text-white bg-[var(--ll-ink)] hover:opacity-90`;
export const btnLight = `${btn} border bg-white hover:bg-[var(--ll-mint)]`;

const pad = (n) => String(n).padStart(2, "0");

export const usDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()}`;
};
export const usDateTime = (iso) => (iso ? `${usDate(iso)} ${new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" })}` : "");

// "YYYY-MM" -> "mm/dd/yyyy" using the last day (or first day when edge="start").
export const monthLabel = (m, edge = "end") => {
  if (!m) return "—";
  const y = Number(m.slice(0, 4));
  const mo = Number(m.slice(5, 7));
  const day = edge === "start" ? 1 : new Date(y, mo, 0).getDate();
  return `${pad(mo)}/${pad(day)}/${y}`;
};

const maskUs = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 8);
  if (d.length > 4) return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
  if (d.length > 2) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return d;
};

const usToMonth = (s) => {
  const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const [, mm, dd, yyyy] = m.map(Number);
  const dt = new Date(yyyy, mm - 1, dd);
  if (dt.getMonth() !== mm - 1 || dt.getDate() !== dd) return null;
  return `${yyyy}-${pad(mm)}`;
};

// mm/dd/yyyy text box bound to a "YYYY-MM" month value (forecasts are monthly).
export function MonthDateInput({ value, onChange, edge = "end", className = "", style, testid, allowEmpty = true }) {
  const [text, setText] = useState(value ? monthLabel(value, edge) : "");
  useEffect(() => { setText(value ? monthLabel(value, edge) : ""); }, [value, edge]);
  const bad = text.length === 10 && usToMonth(text) === null;
  return (
    <input
      type="text"
      inputMode="numeric"
      placeholder="mm/dd/yyyy"
      value={text}
      onChange={(e) => {
        const t = maskUs(e.target.value);
        setText(t);
        if (!t && allowEmpty) onChange("");
        const m = usToMonth(t);
        if (m) onChange(m);
      }}
      className={className}
      style={{ ...style, ...(bad ? { borderColor: "var(--ll-error)" } : {}) }}
      data-testid={testid}
    />
  );
}
